import { cacheProvider } from '@logz-pkg/frontend-services';
import moment from 'moment';

export const hideModalInNewApp = () => {
  cacheProvider.setPersistentTtl(
    cacheProvider.CacheKeys.NEW_APP_TEMPORARY_INTENDED,
    true,
    moment.duration(1, 'minutes').asMilliseconds(),
  );
};
